import { QueryClient } from '@tanstack/react-query';

export const queryClient: QueryClient = new QueryClient({
	defaultOptions: {
		mutations: {
			retry: 3,
		},
	},
});
